export default __webpack_public_path__ + "static/hotel-room-905b25df7a7d8e80ea9991f1704f8c5f.jpg";